<template>
  <Card cardClasses="shadow-sm border-0">
    <!-- Header Section -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="m-0 text-primary">
        <i class="bi bi-person-plus me-2"></i>Add New Customer
      </h4>
      <div>
        <button class="btn btn-outline-secondary" @click="$router.go(-1)">
          <i class="bi bi-arrow-left me-1"></i> Back
        </button>
      </div>
    </div>

    <div class="container-fluid p-0">
      <div class="customer-form-content fade-in">
        <form @submit.prevent="submitForm">
          <!-- Basic Information Section -->
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-header bg-light py-3">
              <h5 class="mb-0"><i class="bi bi-info-circle me-2"></i>Customer Information</h5>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="form-group col-md-6">
                  <label for="name" class="form-label fw-bold">Name:</label>
                  <input type="text" class="form-control" placeholder="Customer name" v-model="customer.name" required>
                </div>
                <div class="form-group col-md-6">
                  <label for="email" class="form-label fw-bold">Email:</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                    <input type="email" class="form-control" placeholder="Email address" v-model="customer.email" required>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="phone" class="form-label fw-bold">Phone:</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-telephone"></i></span>
                    <input type="text" class="form-control" placeholder="Phone number" v-model="customer.phone" required>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="address" class="form-label fw-bold">Address:</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
                    <input type="text" class="form-control" placeholder="Physical address" v-model="customer.address" required>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex justify-content-center gap-3 mt-4 mb-3">
            <button class="btn btn-outline-secondary px-4" @click="$router.go(-1)">
              <i class="bi bi-arrow-left me-1"></i> Cancel
            </button>
            <button v-if="profile.role !== 'user'" type="submit" class="btn btn-primary px-4">
              <i class="bi bi-check-lg me-1"></i> Save Customer
            </button>
          </div>
        </form>
      </div>
    </div>
  </Card>
</template>

<script>
import customerService from "@/api/customerService";
import {decrypt} from "@/utils/crypto";
import loadingButton from "@/utils/loadingButton";

export default {
  name: "AddCustomer",

  data() {
    this.organization = JSON.parse(decrypt(sessionStorage.getItem('organization')))
    return {
      profile: {},
      organization: {},
      customer: {
        organization_id: this.organization.id,
        name: '',
        email: '',
        phone: '',
        address: ''
      }
    }
  },

  methods: {
    async submitForm(e) {
      try {
        loadingButton(e);
        await customerService.createCustomer(this.customer);
      } catch (error) {
        console.error("Error creating customer:", error);
      } finally {
        loadingButton(e, false);
      }
    },
  },

  async created() {
    try {
      this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')));
    } catch (error) {
      console.error("Error in created lifecycle hook:", error);
    }
  },
}
</script>

<style scoped>
.customer-form-content {
  padding: 0.5rem;
}
</style>
